import React from "react";
// Import Footer Data
import { FooterData } from "./FooterData";
// Import Link
import { Link } from "react-router-dom";

const Footer = () => {

 
    const handleLinkClick = () => {
      window.scrollTo(0, 0); // Scroll to the top
    };
  return (
    <>
      <footer id="footer_area">
        <div className="container">
          <div className="row">
            <div className="col-lg-3 col-md-6 col-sm-6 col-12">
              <div className="footer_heading_area">
                <h5>Need any help?</h5>
              </div>
              <div className="footer_first_area">
                <div className="footer_inquery_area">
                  <h5>Call 24/7 for any help</h5>
                  <h3>
                    {" "}
                    <a href="tel:+02132410444">(021) 32410444</a>
                  </h3>
                </div>
                <div className="footer_inquery_area">
                  <h5>Mail to our support team</h5>
                  <h3>
                    {" "}
                    <a href="mailto:support@houseofpolani.pk">
                      support@houseofpolani.pk
                    </a>
                  </h3>
                </div>
                <div className="footer_inquery_area">
                  <h5>Follow us on</h5>
                  <ul className="soical_icon_footer">
                    <li>
                      <a href="https://www.facebook.com/PolanisTravels/">
                        <i className="fab fa-facebook"></i>
                      </a>
                    </li>
                    {/* <li>
                      <a href="#!">
                        <i className="fab fa-twitter-square"></i>
                      </a>
                    </li> */}
                    <li>
                      <a href="https://www.instagram.com/polanitravels/?igsh=NmVjbnQ5Nm53cDht#">
                        <i className="fab fa-instagram"></i>
                      </a>
                    </li>
                    <li>
                      <a href="https://www.youtube.com/@houseofpolanitravel/">
                      <i className="fab fa-youtube"></i>
                      </a>
                    </li>
                    <li>
                      <a href="https://www.tiktok.com/@Houseofpolani">
                      <i className="w-20">
    <svg
      className="tiktok-cus-svg"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 448 512"
      width="16"
      height="14"
      fill="#ad865d"
    >
      <path d="M448,209.09a139.78,139.78,0,0,1-77.44-23.5V329.22a175.46,175.46,0,0,1-175.55,175.4c-26.11,0-52.26-6.33-76.32-18.33-36.5-18.2-63.48-50.62-76.91-89.59A171.59,171.59,0,0,1,32,321.63c0-74.63,48.28-138.53,117.87-160.23a172.77,172.77,0,0,1,57.15-7.65c0,16.32.13,32.63.13,48.94-27.71-1.73-55.41,7.18-78.3,25.88A113.35,113.35,0,0,0,96,322.47c0,61.81,50.07,112.05,111.79,112.05a112.44,112.44,0,0,0,112.57-112.05V0h64A140.07,140.07,0,0,0,448,209.09Z"/>
    </svg>
  </i>
                      </a>
                    </li>

                    {/* <li>
                      <a href="#!">
                        <i className="fab fa-linkedin"></i>
                      </a>
                    </li> */}
                  </ul>
                </div>
              </div>
            </div>

            {FooterData.map((data, index) => (
              <div
                className={
                  data.offset === true
                    ? "col-lg-2  col-md-6 col-sm-6 col-6 offset-lg-1"
                    : "col-lg-2  col-md-6 col-sm-6 col-6"
                }
                key={index}
              >
                <div className="footer_heading_area">
                  <h5>{data.heading}</h5>
                </div>
                <div className="footer_link_area">
                  <ul>
                    {data.item.map((data1, index1) => (
                      <li key={index1}>
                        <Link to={data1.linkL} onClick={handleLinkClick}>{data1.FItem}</Link>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
